import DefaultButton from '../../components/Button/Button'
import PageWrapper from '../../components/PageWrapper'
import React from 'react'
import EstateService from '../../api/estate-service'
import { showToast } from '../../utils/toast'
import { useNavigate, useParams } from 'react-router-dom'
import { EstateDto } from '../../interfaces/estate'
import StaffService from '../../api/staff-service'
import { setLocals } from '../../utils/local'
import usePermission from '../../hooks/usePermission'

const EditEstate = () => {
  const navigate = useNavigate()
  let { estateId } = useParams()
  const [estate, setEstate] = React.useState<EstateDto>({
    name: '',
    address: '',
    code: '',
    contact: '',
    isVerified: true,
    logo: '',
  })
  const { getDefaultRoute } = usePermission()

  const [loading, setLoading] = React.useState(true)

  React.useEffect(() => {
    EstateService.getEstateById(estateId!)
      .then((data) => {
      
        setEstate(data?.data as EstateDto)
      })
      .catch((err) => {
        showToast({
          description: err.message,
          status: 'error',
          id: 'get-estate-error',
          title: 'Error',
        })
        // navigate('/estates')
      })
      .finally(() => {
        setLoading(false)
      })
  }, [estateId])

  const handleGetAccess = (id: string) => {
    StaffService.getStaffEstateAccess(id)
      .then((data) => {
        setLocals({
          token: data.tokens.access.token,
          refreshToken: data.tokens.refresh.token,
          user: data.data.staff,
          estate: data.data.estate,
          permissions: data.data.permissions,
        })
        const route = getDefaultRoute(data.data.permissions)
        navigate(route)
      })
      .catch((err) => {
        showToast({
          id: 'estate-access-error',
          title: 'Access error',
          description: err.message,
          status: 'error',
        })
      })
  }
  return (
    <PageWrapper title="View Estate" description="View and edit your estate details">
      <DefaultButton
        text={'Get Access'}
        className="sm:w-52 grow sm:grow-0 hover:grow-[9] hover:sm:grow-0"
        onClick={() => handleGetAccess(estateId!)}
      />
      {/* <div className="md:container">

        <FormInput value={""} onChange={function (e: ChangeEvent<any>): void {
          throw new Error("Function not implemented.");
        } } name={""} label="Estate name" size={"sm"} className="w-80"/>
          
       
        
      <div className="flex justify-end gap-5 sm:mt-20 mt-10">
              <DefaultButton
                text={"Save"}
                className="sm:w-52 grow sm:grow-0 hover:grow-[9] hover:sm:grow-0"
              />
            </div>
      </div> */}

      <div className="border">
        <div className="">Name: {estate.name}</div>
        <div>Address: {estate.address}</div>
        <div>Manager Details {loading}</div>

        <div className="flex justify-end gap-5 sm:mt-20 mt-10">
          <DefaultButton
            text={'Save'}
            className="sm:w-52 grow sm:grow-0 hover:grow-[9] hover:sm:grow-0"
            disabled
          />
        </div>
      </div>
    </PageWrapper>
  )
}

export default EditEstate
